import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/layout/app-layout/app-layout';
import InboxTab from './InboxTab';
import styles from './page-inbox.module.scss';
import appState from '../../state/AppStateContainer';

const storageKey = () => {
  const id = appState.state.token?.id;
  return id ? `inbox_welcome_seen_${id}` : null;
};

const PageInbox: FC = () => {
  const [t] = useTranslation('dashboard');

  return (
    <AppLayout title={t('inbox.title', 'Inkorg')}>
      <div className={styles.container}>
        <InboxTab />
      </div>
    </AppLayout>
  );
};

export default PageInbox;
